import YouTube from 'react-youtube';
import styled from 'styled-components';
import { formatYoutubeURL } from '../../../utils/formatter/formatYoutubeURL.util';

interface YoutubeSectionProps {
  youtubeUrl: string;
  onPlay?: () => void;
  onEnd?: () => void;
}

export const YoutubeSection = ({ youtubeUrl, onPlay, onEnd }: YoutubeSectionProps) => {
  return (
    <YouTubeWrapper>
      <CustomYoutube
        videoId={formatYoutubeURL(youtubeUrl)}
        onPlay={onPlay && (() => onPlay())}
        onEnd={onEnd && (() => onEnd())}
      />
    </YouTubeWrapper>
  );
};

const YouTubeWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-offblack, #505363);

  overflow: hidden;
`;

const CustomYoutube = styled(YouTube)`
  iframe {
    position: absolute;
    width: 100%; /* 비울 16: 9. */
    height: 100%;
  }
`;
